/*
Saimaheshwar 09/26/2022  2698947782 changed button UI for delete popup
Poornima     09/29/2022  2700799562 Search field list changes
Aditya       10/03/2022  2698947782 Implemented Draggable dialog box for Delete pop-ups
Ashraf       10/03/2022  2698947782 Added custom windows code comments
Prakash       26/10/2022  2698947782 Added classes for Buttons.
Ashraf 11/01/2022 2698947782 added tooltip to close icon
Rohini 11/01/2022 2698947782 added the class name for delete popups button
Suresh Peddavoora 11/22/2022 2698947782 - Modified Spacing Alignments for DialogBox Content.
Dilip 12/12/2022 2698947782 changed tooltip
sai krisha 01/17/2023 2698947782 added preprocessor name for delete popup
suresh peddavoora 02/22/2023 2698947782 New UI changes

 */
import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import reusableInputStyles from '../components/InputStyles';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {Divider, Tooltip} from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}
// reusable popup for delete operation
const DeleteTableRecordPopup = ({
  open,
  dialogClose,
  title,
  maxWidth,
  value,
  handleSubmit,
  condition,
  buttonCondition,
  deleteRecord,
  disabled = false,
}) => {
  const classes = reusableInputStyles();
  return (
    <Dialog
      onClose={dialogClose}
      aria-labelledby="draggable-dialog-title"
      open={open}
      fullWidth
      maxWidth={maxWidth}
      PaperComponent={PaperComponent}
    >
      <DialogTitle id="draggable-dialog-title" style={{cursor: 'move'}} className="delete-table">
        <Typography variant="h4">{title}</Typography>
        <Tooltip title="Close">
          <IconButton aria-label="close" onClick={dialogClose}>
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </DialogTitle>
      <Divider />
      <div className={classes.dialoguecardStyles}>
        <div className="text-center my-3">
          {value ? (
            <Typography variant="h4">{value}</Typography>
          ) : (
            <Typography variant="h4">{`Are you sure want to delete ${deleteRecord?.preprocessorName?.replace(/ /g, '\u00a0')} ?`}</Typography>
          )}
        </div>
        <div className="button-table-spacing-mb new-standard-textfields">
          {buttonCondition === 'Default Audit' ? (
            <Button
              onClick={() => dialogClose()}
              type="button"
              variant="outlined"
              className={`reset-btn mr-1 ${classes.buttonRoot}`}
            >
              Close
            </Button>
          ) : buttonCondition ? (
            <>
              <Button
                onClick={() => dialogClose()}
                type="button"
                variant="outlined"
                className={`reset-btn mr-1 ${classes.buttonRoot}`}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="outlined"
                className={`search-btn ml-1 ${classes.buttonRoot}`}
                onClick={() => handleSubmit()}
              >
                View Usage
              </Button>
            </>
          ) : (
            <>
              <Button
                onClick={() => dialogClose()}
                type="button"
                variant="outlined"
                className={` search-btn  mr-1 ${classes.buttonRoot}`}
                // className={`mx-1 ${classes.buttonRoot}`}
              >
                No
              </Button>
              <Button
                type="submit"
                variant="outlined"
                // className={`themeing-buttons mx-2 ${classes.buttonRoot}`}
                className={`ml-1 reset-btn ${classes.buttonRoot}`}
                onClick={() => handleSubmit()}
                disabled={disabled}
              >
                Yes
              </Button>
            </>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default DeleteTableRecordPopup;
